import { axInst } from "../../components/Service/Service";

export const getDisplayRecords = async () => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}displayRecords`,
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching displayRecords:", error);
    throw error;
  }
};

export const updateRecord = async (records, useDetailsToken) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}updateRecord`,
      { records, useDetailsToken }   // send all edited rows together
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching updateRecord:", error);
    throw error;
  }
};